import React from "react";

const EnquiryInfoCard = ({ enquiryData }) => {
  // Format date strings
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date(dateString));
  };

  // Render key-value pair
  const renderItem = (label, value) => {
    const displayValue = value === null || value === undefined ? "N/A" : value;

    if (label === "status") {
      const statusText = displayValue === 2 ? "Pending" : "Unknown";
      return (
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className="fw-semibold text-capitalize text-secondary">
            {label.replace(/_/g, " ")}:
          </span>
          <span className="badge bg-warning text-dark">{statusText}</span>
        </li>
      );
    }

    return (
      <li className="list-group-item d-flex justify-content-between align-items-center">
        <span className="fw-semibold text-capitalize text-secondary">
          {label.replace(/_/g, " ")}:
        </span>
        <span className="text-dark text-capitalize">{displayValue}</span>
      </li>
    );
  };

  return (
    <div className="card shadow-lg border-0 rounded-3 overflow-hidden">
      {/* Header */}
      <div className="card-header bg-primary text-white text-center py-3">
        <h2 className="h4 fw-bold mb-0">Enquiry Details</h2>
      </div>

      {/* Body */}
      <div className="card-body p-4">
        <ul className="list-group list-group-flush">
          {Object.entries(enquiryData).map(([key, value]) => {
            // Skip fields we don’t want to render
            if (["created_at", "updated_at", "product", "id", "product_id", "enquiry_by", "p_user_id", "s_availability", "s_price", "status"].includes(key)) {
              return null;
            }
            return (
              <React.Fragment key={key}>{renderItem(key, value)}</React.Fragment>
            );
          })}
        </ul>
      </div>

      {/* Footer */}
      <div className="card-footer bg-light small text-muted d-flex justify-content-between">
        <span>Created: {formatDate(enquiryData.created_at)}</span>
        <span>Updated: {formatDate(enquiryData.updated_at)}</span>
      </div>
    </div>
  );
};

export default EnquiryInfoCard;